import { FlatFileObjectConfigFormReducerActions } from '../reducer/factory';
import { useQuery } from '../../../../../../request/hooks/useQuery';
import { GenericApiResponse } from '../../../../../../shared/interfaces/generics';
import { getErrorMessageFromAxiosError } from '../../../../../../request/utils';
import {
  AsyncTaskStatus,
  AsyncTaskStatusResponse
} from '../../../../../../shared/interfaces/async-task';
import { SourceAPI } from '../../../../../../sources/api/SourceAPI';

export function useInferSchema(reducerActions: FlatFileObjectConfigFormReducerActions) {
  const { fetch } = useQuery({
    dataSource$: args =>
      SourceAPI.getInferSchemaStatus(args as { taskFlowId: string; sourceId: number }),
    pollInterval: 10000,
    pollUntil: res => {
      const { task_status: taskStatus } = (res as GenericApiResponse<AsyncTaskStatusResponse>).data;
      return taskStatus === AsyncTaskStatus.EXECUTING;
    },
    fetchSuccess: res => {
      const {
        task_status: taskStatus,
        error_message: errorMessage,
        success_data: successResponse
      } = (res as GenericApiResponse<AsyncTaskStatusResponse<{ source_object_id: string }>>).data;

      const isInferSchemaSuccessful = taskStatus === AsyncTaskStatus.EXECUTED;
      const isInferSchemaFailed = taskStatus === AsyncTaskStatus.FAILED;

      if (isInferSchemaSuccessful) {
        const objectId = successResponse?.source_object_id;
        reducerActions.saveInferSchemaSuccess(objectId!);
      }

      if (isInferSchemaFailed) {
        reducerActions.saveInferSchemaError(errorMessage!);
      }
    },
    fetchError: e => {
      const errorMessage = getErrorMessageFromAxiosError(e);
      reducerActions.saveInferSchemaError(errorMessage);
    }
  });

  return {
    pollInferSchemaStatus: (taskFlowId: string, sourceId: number) => fetch({ taskFlowId, sourceId })
  };
}
